import React from 'react';
import { Select, SelectItem, IndexPath } from '@ui-kitten/components';
import theme from "./DNASelect.theme.alucio";
// @ts-expect-error - Typical SubComponent type issues with forwardRef
export const DNASelect = React.forwardRef((props, ref) => (<Select ref={ref} {...props} status={props.status ?? 'basic'} size={props.size ?? 'md'}/>));
DNASelect.Item = SelectItem;
DNASelect.Index = IndexPath;
export default DNASelect;
//# sourceMappingURL=DNASelect.js.map